// src/pages/VerifyCode.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API_URL from "../config";
import "./VerifyCode.css";
import axios from "axios";

export default function VerifyCode() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!code) return alert("Entrez le code reçu");

    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}/api/auth/verify-code`, { email, code });

      if (res.data.success) {
        alert("✅ Code validé !");
        navigate("/reset-password", { state: { email } });
      } else {
        alert(res.data.message || "Code invalide");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-container">
      <h1>Vérification du code</h1>
      <form onSubmit={handleVerify}>
        <input
          type="text"
          placeholder="Code reçu par email"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Vérification..." : "Vérifier"}
        </button>
      </form>
    </div>
  );
}
